import AlertModal from "../components/others/AlertModal";
import LayoutBase from "../layout/layoutBase";
import { AlertProvider } from "./AlertProvider";

export default function App() {
  return (
    <AlertProvider>
      {/* <Notification /> */}
      <LayoutBase />
      <AlertModal />
    </AlertProvider>
  );
}
